<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-text>
                    <h1>Chart Of Account</h1>
                    <hr>

                    <!-- Search account id and account name -->
                    <v-layout justify-center>
                        <v-flex xs2 text-xs-center my-4><h3>Search account id:</h3></v-flex>
                        <v-flex xs2 pa-1 px-2>
                            <v-text-field v-model="searchAccId" ref="focusSearchAccId" @keypress.enter="getAccId"></v-text-field>
                        </v-flex>
                        <v-flex xs1 my-2>
                            <v-btn fab small color="indigo lighten-1" dark @click="getAccId">
                                <v-icon>search</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs2 text-xs-center my-4><h3>Search account name:</h3></v-flex>
                        <v-flex xs3 pa-1 px-2>
                            <v-text-field v-model="searchAccName" ref="focusSearchAccName" @keypress.enter="getAccName"></v-text-field>
                        </v-flex>
                        <v-flex xs1 my-2>
                            <v-btn fab small color="indigo lighten-1" dark @click="getAccName">
                                <v-icon>search</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <hr>

                    <!-- Add new account -->
                    <v-layout>
                        <v-flex xs1 my-2>
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-btn fab small color="primary" @click="dialogNew = true" v-on="on"><v-icon dark>add</v-icon></v-btn>
                                </template>
                                <span>Add new account</span>
                            </v-tooltip>
                            <v-dialog v-model="dialogNew" persistent max-width="600px">
                                <v-card>
                                    <v-card-text>
                                        <span class="headline"><v-icon>account_balance_wallet</v-icon>New Account</span>
                                        <v-container grid-list-md>
                                            <v-layout>
                                                <v-flex xs4>
                                                    <v-text-field v-model="accId" label="Account id:" ref="focusAccId"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex>
                                                    <v-text-field v-model="accName" label="Account name:" ref="focusAccName"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs2>
                                                    <v-select :items="cashItem" v-model="cash" label="Cash:"></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="red darken-1" flat @click="cancelNewAcc">Cancel</v-btn>
                                        <v-btn color="blue darken-1" flat @click="addNewAcc">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-flex>
                    </v-layout>
                    <hr>

                    <!-- Account Detail -->
                    <v-data-table :headers="headersAcc" :items="accDetail" class="elevation-1" v-bind:pagination.sync="pagination">
                        <template v-slot:no-data>
                            <!-- <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear> -->
                            <v-alert class="text-center" color="info" icon="info" :value="true" outline>
                                Please search with account id or account name
                            </v-alert>
                        </template>
                        <template v-slot:items="props">
                            <td>{{props.item.accId}}</td>
                            <td>{{props.item.accName}}</td>
                            <td class="text-xs-center">{{props.item.cash}}</td>
                            <!-- <td class="justify-center layout px-0" v-if="isAdmin==true">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-1" @click="editCust(props.item)" v-on="on">edit</v-icon>
                                    </template>
                                    <span>Edit customer</span>
                                </v-tooltip>
                            </td> -->
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            searchAccId: '',
            searchAccName: '',

            dialogNew: false,
            checkDoc: [],

            accId: '',
            accName: '',
            cashItem: ['Y','N'],
            cash: '',

            headersAcc: [
                { text: 'Account id', value: 'accId' },
                { text: 'Account name', sortable: false},
                { text: 'Cash', align: 'center', sortable: false},
            ],
            pagination: {'sortBy': 'accId', 'descending': false},
            accDetail: [],
        }  
    },
    methods:{

        // Search account id info from database
        getAccId(){
            if(this.searchAccId == ''){
                alert("Please enter account id.")
                this.$nextTick(()=>{this.$refs.focusSearchAccId.focus()})
            }
            else{
                db.collection("chartAccount").orderBy("accId").startAt(this.searchAccId).endAt(this.searchAccId+ "\uf8ff").get()
                .then(snapshot=>{
                    this.accDetail = []
                    snapshot.forEach(doc=>{
                        this.accDetail.push(doc.data())
                    })
                    if(this.accDetail.length == 0){
                        alert("This account id does not exist in the system.\nPlease enter account id again.")
                        this.searchAccId = ''
                    }
                    else{
                        this.searchAccId = ''
                    }
                })
            }
        },

        // Search account name info from database
        getAccName(){
            if(this.searchAccName == ''){
                alert("Please enter account name.")
                this.$nextTick(()=>{this.$refs.focusSearchAccName.focus()})
            }
            else{
                db.collection("chartAccount").orderBy("accName").startAt(this.searchAccName).endAt(this.searchAccName+ "\uf8ff").get()
                .then(snapshot=>{
                    this.accDetail = []
                    snapshot.forEach(doc=>{
                        this.accDetail.push(doc.data())
                    })
                    if(this.accDetail.length == 0){
                        alert("This account name does not exist in the system.\nPlease enter account name again.")
                        this.searchAccName = ''
                    }
                })
            }
        },

        // Add new account to the database
        addNewAcc(){
            if(this.accId == ''){
                alert("Please enter account id.")
                this.$nextTick(()=>{this.$refs.focusAccId.focus()})
            }
            else if(this.accName == ''){
                alert("Please enter account name.")
                this.$nextTick(()=>{this.$refs.focusAccName.focus()})
            }
            else if(this.cash == ''){
                alert("Please select cash.")
            }
            else{
                db.collection("chartAccount").where("accId", "==", this.accId).get()
                .then(snapshot=>{
                    this.checkDoc = []
                    snapshot.forEach(doc=>{
                        this.checkDoc = doc.data()
                    })
                    if(this.checkDoc.length == 0){
                        db.collection("chartAccount").add({
                            accId: this.accId,
                            accName: this.accName,
                            cash: this.cash
                        })
                        .then(()=>{
                            this.addNewAccBalance()
                            // alert("Success.")
                            // this.cancelNewAcc()
                        })
                    }
                    else{
                        alert("This account id already exists in the system.\nPlease enter a new account id.")
                    }
                })
            }
        },

        // Add new account balance
        addNewAccBalance(){
            let year = new Date().toISOString().substr(0,4)
            db.collection("accBalance").doc(year)
            .set({
                [this.accId]:{accName: this.accName, "01": 0, "02": 0, "03": 0, "04": 0, "05": 0, "06": 0, "07": 0, 
                            "08": 0, "09": 0, "10": 0, "11": 0, "12": 0, debit: 0, credit: 0}
            }, { merge: true })
            .then(()=>{
                alert("Success.")
                this.cancelNewAcc()
            })
        },
        
        // Cancel add new account
        cancelNewAcc(){
            this.accId = ''
            this.accName = ''
            this.cash = ''
            this.dialogNew = false
        }
    },
    mounted(){
        this.$nextTick(()=>{this.$refs.focusSearchAccId.focus()})
    }
}
</script>
